import MiniFormBox from './src/MiniFormBox'

MiniFormBox.install = function (Vue) {
    Vue.component(MiniFormBox.name, MiniFormBox);
};

export default MiniFormBox;